import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageService {
  /** Subject for monitoring the state of the top menu bar*/
  private hideMenuListener = new Subject();

  constructor() {}
  /** Subscribe to watch the state of the top menu*/
  hideMenuUpdates(): Observable<any> {
    return this.hideMenuListener;
  }
  /**
   * Set the state of the top menu
   * @param hideMenu Should menu be hidden
   */
  updateHideMenu(hideMenu: boolean) {
    this.hideMenuListener.next(hideMenu);
  }
}
